import React from "react"
import { Link } from "gatsby"
import styles from "./products.module.css"

import Growth from "assets/icons/growth.svg"
import Pig from "assets/icons/pig.svg"
import Habit from "assets/icons/habit.svg"
import Received from "assets/icons/received.svg"

const Products = () => {
  return (
    <section className={styles.products}>
      <div className="wrapper">
        <h2>Produtos para todos os momentos</h2>
        <ul className={styles.features}>
          <li>
            <Link to="/produtos/educacao-financeira">
              <figure>
                <Growth className={styles.icon} />
                <figcaption>
                  <h3>Educação financeira</h3>
                </figcaption>
              </figure>
            </Link>
          </li>
          <li>
            <Link to="/produtos/poupe-facio">
              <figure>
                <Pig className={styles.icon} />
                <figcaption>
                  <h3>Poupe Facio</h3>
                </figcaption>
              </figure>
            </Link>
          </li>
          <li>
            <Link to="/produtos/antecipacao-de-salario">
              <figure>
                <Habit className={styles.icon} />
                <figcaption>
                  <h3>Antecipação de salário</h3>
                </figcaption>
              </figure>
            </Link>
          </li>
          <li>
            <Link to="/produtos/credito-consignado">
              <figure>
                <Received className={styles.icon} />
                <figcaption>
                  <h3>Crédito consignado</h3>
                </figcaption>
              </figure>
            </Link>
          </li>
        </ul>
      </div>
    </section>
  )
}

export default Products
